import { HttpStatusCode } from "axios";
import { alertConstants } from "../../helper/sweet-alert";
import TechnologyResourceService from "../../apiServices/masters/technologyResourceService";
import { setTechnologyResource, setTechnologyResources } from "../../store/slices/master/technologyResourceSlice";

export function getTechnologyResource(id: number) {
  return async function (dispatch: any, getState: any) {
    let response = await TechnologyResourceService.getTechnologyResource(id);
    if (response?.success === true) {
      dispatch(setTechnologyResource(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getTechnologyResources(configUserRole?: number, pageBlockId?: number, collegeId?: number, departmentId?: number, noOfItems?: number,) {
  return async function (dispatch: any, getState: any) {
    let response = await TechnologyResourceService.getTechnologyResources(configUserRole, pageBlockId, collegeId, departmentId, noOfItems);
    if (response?.success === true) {
      dispatch(setTechnologyResources(response.data));
    } else {
      console.log("error");
    }
  };
}


export function createTechnologyResource(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await TechnologyResourceService.createTechnologyResource(data);
    const name = data.get("resourceName")
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict, name);
      }
      else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateTechnologyResource(data: any, id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await TechnologyResourceService.updateTechnologyResource(data, id);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateTechnologyResourcePriority(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await TechnologyResourceService.updateTechnologyResourcePriority(data);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      callback(alertConstants.error);
    }
  };
}

export function deleteTechnologyResource(id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await TechnologyResourceService.deleteTechnologyResource(id);
    if (response === true) {
      callback(alertConstants.inactiveSuccess);
    } else {
      callback(alertConstants.inactiveFailure);
    }
  };
}
